export function handleError(error) {
    if (process.env.NODE_ENV !== 'development' && window.Sentry) {
        window.Sentry.captureException(error);
    }
}
